import React, { ReactElement } from "react";
import { Global, css } from "@emotion/react";

export const FilterApplyButtonMobileCss = (): ReactElement => {
  /**
   * CSS override description:
   * - Styles for Apply button container in mobile view
   */

  return (
    <Global
      styles={css`
        /* Spark-React styles for Apply button container in mobile view */
        .spark-filter--dropdown .spark-filter__footer {
          position: sticky;
          z-index: 101;
          bottom: 0;
        }

        .spark-filter__footer--floating {
          border-radius: 1rem 1rem 0 0;
          -webkit-box-shadow: 0 1px 12px 0 rgba(18, 19, 21, 0.08);
          box-shadow: 0 1px 12px 0 rgba(18, 19, 21, 0.08);
        }
      `}
    />
  );
};
